<template>
  <v-card class="promo-card" @click="close"> <!-- Agrega el evento de clic aquí -->
    <v-container fluid @click.stop> <!-- Usa stop para prevenir que este clic propague al v-card -->
      <v-list-item-action class="close-icon">
        <v-icon class="icon" @click.stop="close">fa-times</v-icon> <!-- Asegúrate de usar stop aquí también -->
      </v-list-item-action>
      <v-row class="content-row">
        <v-col cols="10" class="text-center">
          <h2 class="custom-color-title">{{ title }}</h2>
          <p class=" custom-description">{{ description }}</p>
          <p class="sale-price" v-if="salePrice"> {{ salePrice }}</p>
          <p class="standard-price" v-if="standardPrice">${{ standardPrice }} usd</p>
          <p class="deadline" v-if="deadline">{{ deadline.toLocaleDateString() }}</p>
          <div class="lottie-container">
            <lottie class="lotti-eBrain" :options="lottieOptions"/>
          </div>
        </v-col>
      </v-row>
      <v-row v-if="endTime !== undefined" justify="center" class="mt-5 custom-counter">
        <div style="display: flex; justify-content: center; width: 100%;">
          <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
            <p>{{ $t('offer') }}</p>
            <Counter :end-time="endTime" />
          </div>
        </div>
      </v-row>
      <v-btn class="button-promo" :href="ctaLink" target="_blank">{{ ctaText || 'See the promo' }}</v-btn>
    </v-container>
  </v-card>
</template>

<script>
import * as animationData from "@/assets/animations/brain.json";
import Counter from "@/components/Counter";

export default {
  name: "DynamicPromoPopup",
  components: { Counter },
  props: {
    title: String,
    description: String,
    standardPrice: Number,
    salePrice: Number,
    endTime: Date,
    ctaText: String,
    ctaLink: String,
    deadline: String,
  },
  data() {
    return {
      lottieOptions: { animationData: animationData.default },
    };
  },
  methods: {
    close() {
      this.$emit("closeWindow");
    },
  },
};
</script>

<style scoped lang="scss">
// Variables
$primary-color: var(--v-mainGreen-base);
$button-width: 356px;

// Base card styling
.promo-card {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  max-width: 416px; // Establece el ancho máximo a 416px
  min-width: 30vw; // Asegura un mínimo de responsividad
  width: 100%; // Asegura que la tarjeta se ajuste al contenedor padre
  margin: 0 auto; // Centra la tarjeta horizontalmente
  border-radius: 15px;
}

// Positioning for close icon
.close-icon {
  position: absolute;
  top: 10px;
  right: 20px;
}

// Styling for content rows
.content-row {
  align-items: center;
  justify-content: center;
}

// Custom title color
.custom-color-title {
  color: $primary-color;
  margin: 0 auto;
}

.custom-counter {
  display: flex;
  justify-content: center;
  align-items: center;
}

// Button styling for both light and dark themes
.theme--light.v-btn,
.theme--dark.v-btn {
  &.v-btn--has-bg.button-promo {
    background-color: $primary-color;
    width: $button-width;
    margin: 0 auto;
    border-radius: 8px;
  }
}

.sale-price,
.standard-price,
.deadline {
  margin-top: 10px;
  font-size: 30px;
  font-weight: bold;
}
.lottie-container {
  width: 250px;
  height: 250px;
  margin: 0 auto; // Centra el contenedor de Lottie
}
.custom-description {
  text-align:center  ; // Justifica el texto de la descripción
  margin: 0 auto; // Centra la descripción
  width: 100%; // Asegura que la descripción ocupe el ancho disponible
  max-width: 416px; // Limita el ancho máximo de la descripción
  color: var(--v-darkGrey-base);
}
</style>


